import { nullishToUndefinedable } from '@repo/platform-utils/valibot';
import * as v from 'valibot';

export const entityPlacementImageSchema = v.object({
  width: v.number('entityPlacementImage.width is required'),
  height: v.number('entityPlacementImage.height is required'),
  source: v.pipe(
    v.string('entityPlacementImage.source is required'),
    v.trim(),
    v.url('entityPlacementImage.source must be a valid URL'),
  ),
  sourceMedium: v.pipe(
    v.string('entityPlacementImage.sourceMedium is required'),
    v.trim(),
    v.url('entityPlacementImage.sourceMedium must be a valid URL'),
  ),
  sourceLarge: v.pipe(
    v.string('entityPlacementImage.sourceLarge is required'),
    v.trim(),
    v.url('entityPlacementImage.sourceLarge must be a valid URL'),
  ),
  resizableImagePath: nullishToUndefinedable(
    v.string('entityPlacementImage.resizableImagePath must be a string when provided'),
  ),
});

const transformedImageSchema = v.object({
  url: v.string('url is required in transformedImage'),
  height: v.number('height is required in transformedImage'),
  width: v.number('width is required in transformedImage'),
});

const baseAvatarUrlSchema = v.object({
  url: v.string('url is required in baseAvatarUrl'),
  size: v.number('size is required in baseAvatarUrl'),
});

const resizableImageSchema = v.object({
  imagePath: v.string('imagePath is required in resizableImage'),
  height: v.number('height is required in resizableImage'),
  width: v.number('width is required in resizableImage'),
});

export const baseImageSchema = v.union(
  [transformedImageSchema, baseAvatarUrlSchema],
  'baseImage must be either a transformed image or base avatar URL',
);

export const imageSizeMapSchema = v.object({
  small: transformedImageSchema,
  medium: transformedImageSchema,
  large: transformedImageSchema,
});

export const transformedImageSizeMapSchema = v.object({
  ...imageSizeMapSchema.entries,
  resizable: resizableImageSchema,
});
